import { type ComponentProps } from 'react';
import { TextField as TackleTextField } from '@tackle-io/platform-ui';
import { InputLabel } from './InputLabel';

interface TextFieldProps extends ComponentProps<typeof TackleTextField> {
  label: string;
  tooltipText?: string;
  dataId?: string;
}

/** A Tackle style text input field that has:
 *  - a label with or without a tooltip
 *  - helper text
 *  - error message display if provided
 */
const TextInputField = ({
  dataId,
  errorMessage,
  value,
  onChange,
  name,
  tooltipText,
  required,
  label,
  helperText,
  numberScale,
  multiline,
  ...inputProps
}: TextFieldProps) => {
  const inputDataId =
    inputProps.type === 'number'
      ? {
          'data-id': dataId,
        }
      : null;
  return (
    <TackleTextField
      data-id={dataId}
      id={name}
      name={name}
      label={
        <InputLabel
          dataId={dataId}
          tooltipText={tooltipText}
          label={label}
          required={required}
        />
      }
      onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target?.value ?? undefined;
        onChange(value);
      }}
      error={errorMessage}
      inputProps={{ ...inputProps, ...inputDataId }}
      disabled={inputProps.disabled}
      noValidate
      helperText={helperText}
      multiline={multiline}
      {...inputProps}
    />
  );
};

export default TextInputField;
